<div class="progress-container">
  <mat-progress-bar mode="indeterminate" *ngIf="isSaving$$ | async"></mat-progress-bar>
</div>
<h2 mat-dialog-title>{{ 'BILLING_CONTACT.TITLE' | translate }}</h2>
<mat-dialog-content>
  <form [formGroup]="formGroup">
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.COMPANY_NAME' | translate }}</glxy-label>
      <input matInput type="text" placeholder="Company name" formControlName="companyName" required />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.NAME' | translate }}</glxy-label>
      <input matInput type="text" placeholder="Name" formControlName="contactName" required />
    </glxy-form-field>
    <glxy-form-field class="email-addresses">
      <glxy-label>{{ 'BILLING_CONTACT.EMAIL_ADDRESS' | translate }}</glxy-label>
      <textarea
        matInput
        required
        matTextareaAutosize
        matAutosizeMinRows="1"
        placeholder="Email address(es)"
        [formControl]="formGroup.get('emailAddresses')"
      ></textarea>
      <glxy-hint>{{ 'BILLING_CONTACT.EMAIL_DELIMITER' | translate }}</glxy-hint>
      <glxy-error *ngIf="formGroup.get('emailAddresses').hasError('required')">
        At least one email address is required
      </glxy-error>
      <glxy-error *ngIf="formGroup.get('emailAddresses').hasError('invalidEmail')">
        Email addresses entered must be valid: example&#64;example.com
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.PHONE_NUMBER' | translate }}</glxy-label>
      <input matInput type="text" placeholder="Phone number" formControlName="phoneNumber" required />
    </glxy-form-field>
    <ng-container *ngIf="(showSubsidiaryChangeWarning$$ | async) === true">
      <glxy-alert type="warning" class="subsidiary-alert">
        <strong>{{ 'SUBSIDIARY_CHANGE_WARNING.WARNING' | translate }}</strong>
        &mdash; {{ 'SUBSIDIARY_CHANGE_WARNING.WILL_REQUIRE_PAYMENT_METHOD' | translate }}
      </glxy-alert>
    </ng-container>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.ADDRESS' | translate }}</glxy-label>
      <input matInput type="text" placeholder="Address" formControlName="address" required />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.COUNTRY' | translate }}</glxy-label>
      <mat-select placeholder="Country" [formControl]="formGroup.get('country')" required>
        <mat-option *ngFor="let country of countries$ | async" [value]="country.code">
          {{ country.name }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.CITY' | translate }}</glxy-label>
      <input matInput type="text" placeholder="City" formControlName="city" required />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.PROVINCE' | translate }}</glxy-label>
      <mat-select placeholder="State/Province" [formControl]="formGroup.get('state')" [required]="stateRequired">
        <mat-option *ngFor="let state of states$$ | async" [value]="state.code">
          {{ state.name }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'BILLING_CONTACT.POSTAL_CODE' | translate }}</glxy-label>
      <input matInput type="text" placeholder="Zip/Postal code" formControlName="postalCode" required />
    </glxy-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" matDialogClose>{{ 'BILLING_CONTACT.CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving$$ | async">
    {{ 'BILLING_CONTACT.SAVE' | translate }}
  </button>
</mat-dialog-actions>
